/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NonPoSupplierRead } from '../models/NonPoSupplierRead';
import type { SpotRateSupplierRead } from '../models/SpotRateSupplierRead';
import type { SupplierDetailsRead } from '../models/SupplierDetailsRead';
import type { SupplierRead } from '../models/SupplierRead';
import type { SupplierSearchField } from '../models/SupplierSearchField';
import type { SupplierSearchRead } from '../models/SupplierSearchRead';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SupplierService {

    /**
     * Get All Suppliers
     * @param limit
     * @param offset
     * @returns SupplierRead Successful Response
     * @throws ApiError
     */
    public static getAllSuppliersSuppliersAllGet(
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<Array<SupplierRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/suppliers/all',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Search Suppliers
     * @param searchField
     * @param searchValue
     * @param opco
     * @returns SupplierSearchRead Successful Response
     * @throws ApiError
     */
    public static searchSuppliersSuppliersSearchGet(
        searchField: SupplierSearchField,
        searchValue: string,
        opco: string,
    ): CancelablePromise<Array<SupplierSearchRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/suppliers/search',
            query: {
                'search_field': searchField,
                'search_value': searchValue,
                'opco': opco,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Supplier Details
     * @param id
     * @returns SupplierDetailsRead Successful Response
     * @throws ApiError
     */
    public static getSupplierDetailsSuppliersIdDetailsGet(
        id: number,
    ): CancelablePromise<SupplierDetailsRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/suppliers/{id}/details',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Non Po Suppliers
     * @param opco
     * @param limit
     * @param offset
     * @returns NonPoSupplierRead Successful Response
     * @throws ApiError
     */
    public static getNonPoSuppliersSuppliersNonPoGet(
        opco: string,
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<Array<NonPoSupplierRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/suppliers/non_po',
            query: {
                'limit': limit,
                'offset': offset,
                'opco': opco,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Spot Rate Suppliers
     * Get suppliers which require spot rates.
     * @param opco
     * @param limit
     * @param offset
     * @returns SpotRateSupplierRead Successful Response
     * @throws ApiError
     */
    public static getSpotRateSuppliersSuppliersSpotRatesGet(
        opco: string,
        limit?: (number | null),
        offset?: (number | null),
    ): CancelablePromise<Array<SpotRateSupplierRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/suppliers/spot_rates',
            query: {
                'limit': limit,
                'offset': offset,
                'opco': opco,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
